<template>
    <div>
        <!-- <headLine></headLine> -->
        <div class="elder_manage_title">
            <p class="title">老干工单派发</p>
        </div>
        <slot name="statistics"></slot>
        <div class="search_wrapper">
            <div class="search_head">
                <span>查询条件</span>
                <!-- <el-button
                    style="float: right; padding: 3px 0; color: #000"
                    type="text"
                    @click="Reset"
                >
                    <i class="el-icon-refresh"></i>
                    刷新页面
                </el-button> -->
                <i
                    class="searchDomw"
                    @click="isSearchContent = !isSearchContent"
                    :class="
                        isSearchContent == true
                            ? 'el-icon-arrow-up'
                            : 'el-icon-arrow-down'
                    "
                ></i>
            </div>
            <div class="search_content" v-show="isSearchContent">
                <div class="search_inline">
                    <QueryForm
                        @QuerySearch="QuerySearch"
                        :queryForm="queryForm"
                    ></QueryForm>
                </div>
                <!-- <div class="arrowDown">
                    <i
                        :class="
                            isSearchContent === true
                                ? 'el-icon-arrow-up'
                                : 'el-icon-arrow-down'
                        "
                        style="color: #000"
                        @click="isSearchContent = !isSearchContent"
                    ></i>
                </div> -->
            </div>
        </div>
        <!-- <global-tag>
      <span slot='title'>老干工单派发</span>
      <div class='search' slot='search'>
        <QueryForm
          @QuerySearch='QuerySearch'
          :queryForm='queryForm'
        ></QueryForm>
      </div>
    </global-tag> -->

        <div style="height: 20px"></div>
        <el-button
            type="success"
            icon="el-icon-plus"
            class="openBtns"
            @click="detailsVisit('新增')"
            >新增
        </el-button>
        <div style="display: none">
            <input
                @change="(e) => uploadInfo(e, '4')"
                id="speechUpload"
                type="file"
            />
        </div>
        <label for="speechUpload" class="labelImportBtn inDwonBtns">
            <span> <i class="el-icon-upload2"></i>导入</span>
        </label>
        <el-button
            type="primary"
            icon="el-icon-download"
            class="button downOutBtns"
            @click="createExcel"
            >导出
        </el-button>
        <el-button
            type="danger"
            icon="el-icon-sold-out"
            class="button modelDownds"
            @click="mobandaochu"
            >模板导出
        </el-button>
        <div style="height: 20px"></div>

        <div>
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    type="index"
                    width="70"
                    label="序号"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="orderNum"
                    label="工单流水号"
                    align="center"
                    width="220"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="customerName"
                    label="客户姓名"
                    align="center"
                    width="180"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>

                <el-table-column
                    prop="customerphone"
                    label="联系方式"
                    align="center"
                    width="150"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="address"
                    label="居住地址"
                    align="center"
                    width="220"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="servetypename"
                    label="服务类别"
                    align="center"
                    width="180"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="timeStart"
                    label="服务开始时间"
                    align="center"
                    width="220"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="timeEnd"
                    label="服务结束时间"
                    align="center"
                    width="220"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="realPeriod"
                    label="时间工作时间/分钟"
                    align="center"
                    width="180"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="estimateLevel"
                    :formatter="estimateLevelFormat"
                    label="客户满意度"
                    align="center"
                    width="120"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    :show-overflow-tooltip="true"
                    width="150"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            @click="detailsVisit('查看', scope.row)"
                            >查看
                        </el-button>
                        <el-button
                            type="text"
                            @click="detailsVisit('派发', scope.row)"
                            >派发
                        </el-button>
                        <!--              <div @click="chehui(scope.row)">撤回</div>-->
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div style="height: 20px"></div>
        <div>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 40, 100]"
                :page-size="query.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
            >
            </el-pagination>
        </div>
        <VisitDialog
            ref="visitDialog"
            v-if="showVisit"
            @updateList="getDataList"
            :show-visit.sync="showVisit"
            :showTitle="showTitle"
            :orderInfo="orderInfo"
        ></VisitDialog>
    </div>
</template>

<script>
import QueryForm from "@/component/queryform2.vue"
import request from "@/utils/request.js"
// import globalTag from '../../components/globalTag'
import VisitDialog from "../component/visitDialog.vue"
import headLine from "../../components/headline"
import { metaDataMgrDao } from "@/api/dao.js"

export default {
    components: {
        // globalTag,
        VisitDialog,
        headLine,
        QueryForm,
    },
    data() {
        return {
            queryForm: {
                orderName: "",
                customerType: "",
                serveproductName: "",
                servestationName: "",
                servePersonName: "",
            },
            isSearchContent: true,
            showVisit: false,
            showTitle: "",
            tableData: [],
            tableProject: [],
            orderInfo: {
                customerName: "",
            },
            totalCount: 0,
            query: {
                pageNum: 1,
                pageSize: 10,
            },
        }
    },
    created() {
        this.getDataList()
        this.getProjectList()
    },
    mounted() {
        if (localStorage.getItem("czUserInfo")) {
            var dataId = JSON.parse(localStorage.getItem("czUserInfo")).dataIds
            this.dataId = dataId
            console.log(this.dataId, "asda")
        }
    },
    methods: {
        Reset() {
            this.queryForm = {}
            this.getDataList()
        },
        getProjectList() {
            let params = {
                pageNo: 1,
                pageSize: 99,
            }
            request({
                url: "/jjyl/admin/product/info/findList",
                method: "POST",
                data: params,
            }).then((res) => {
                if (res.code === 200 && res.content) {
                    this.tableProject = res.content.list || []
                }
            })
        },
        mobandaochu() {
            this.request2({
                url: "/jjyl/servicePgd/info/Templatedownload",
                method: "POST",
                data: {
                    pageNo: this.query.pageNum,
                    pageSize: this.query.pageSize,
                },
                responseType: "blob",
            }).then((resp) => {
                if (resp) {
                    const blob = new Blob([resp], {
                        type: "application/vnd.ms-excel",
                    })
                    const fileName = "模板导出.xls"
                    const linkNode = document.createElement("a")
                    linkNode.download = fileName //a标签的download属性规定下载文件的名称
                    linkNode.style.display = "none"
                    linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
                    document.body.appendChild(linkNode)
                    linkNode.click() //模拟在按钮上的一次鼠标单击
                    URL.revokeObjectURL(linkNode.href) // 释放URL 对象
                    document.body.removeChild(linkNode)
                    this.$message.success("导出成功")
                }
            })
        },

        createExcel() {
            this.request2({
                url: "/jjyl/servicePgd/info/export",
                method: "POST",
                excel: true,
                data: {
                    customerphone: this.queryForm.customerphone,
                    pageNo: this.query.pageNum,
                    pageSize: this.query.pageSize,
                    orderNum: this.queryForm.orderNum,
                    states: "0",
                    type: this.queryForm.customerType || "4",
                    // customerType: this.queryForm.customerType,
                    customerName: this.queryForm.customerName,
                    timeStart: this.queryForm.timeStart,
                    timeEnd: this.queryForm.timeEnd,
                    position: this.queryForm.position,
                    servestationName: this.queryForm.servestationName,
                    serveproductName: this.queryForm.serveproductName,
                    servePersonName: this.queryForm.servePersonName,
                },
                responseType: "blob",
            }).then((res) => {
                if (res) {
                    const blob = new Blob([res], {
                        type: "application/vnd.ms-excel",
                    })
                    const fileName = "老干工单.xls"
                    const linkNode = document.createElement("a")
                    linkNode.download = fileName //a标签的download属性规定下载文件的名称
                    linkNode.style.display = "none"
                    linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
                    document.body.appendChild(linkNode)
                    linkNode.click() //模拟在按钮上的一次鼠标单击
                    URL.revokeObjectURL(linkNode.href) // 释放URL 对象
                    document.body.removeChild(linkNode)
                    this.$message.success("导出表格成功")
                }
            })
        },

        async fileChange(event) {
            const file = event.target.files[0]
            const personType = "1"
            let config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
            let formData = new FormData()
            formData.append("personType", personType)
            formData.append("file", file)
            let result = await this.$http.post(
                "/jjyl/servicePgd/info/ServicePgdExcel",
                formData,
                config
            )
            // 清空文件
            const fileEle = document.getElementById("speechUpload")
            fileEle.value = ""
            if (result.code === 200) {
                this.$message.success(result.message)
                this.getDataList()
            } else {
                this.$message.warning(result.message)
            }
        },
        getDataList() {
            let params = {
                customerphone: this.queryForm.customerphone,
                pageNo: this.query.pageNum,
                pageSize: this.query.pageSize,
                orderNum: this.queryForm.orderNum,
                states: "0",
                type: this.queryForm.customerType || "4",
                customerUserType: this.queryForm.customerUserType,
                customerName: this.queryForm.customerName,
                timeStart: this.queryForm.timeStart,
                timeEnd: this.queryForm.timeEnd,
                position: this.queryForm.position,
                servestationName: this.queryForm.servestationName,
                serveproductName: this.queryForm.serveproductName,
                servePersonName: this.queryForm.servePersonName,
                provinceId: this.queryForm.provinceId,
                cityId: this.queryForm.cityId,
                areaId: this.queryForm.areaId,
                streetId: this.queryForm.streetId,
                communityId: this.queryForm.communityId,
                city: "",
                zone: "",
                street: "",
                shequ: "",
                // dataId: JSON.parse( localStorage.getItem("czUserInfo")).dataIds,
            }
            request({
                url: "/jjyl/servicePgd/info/findServicepgd",
                method: "POST",
                data: params,
            }).then((res) => {
                if (res.code === 200) {
                    if (res.content) {
                        this.tableData = res.content.list
                        this.totalCount = res.content.count
                    } else {
                        this.tableData = []
                        this.totalCount = 0
                    }
                }
            })
        },
        statesFormat(row, column) {
            if (row.states === 0) {
                return "待派发"
            } else if (row.states === 1) {
                return "待处理"
            } else if (row.states === 2) {
                return "待回访"
            } else if (row.states === 3) {
                return "服务完成"
            } else if (row.states === 4) {
                return "待作废"
            } else if (row.states === 5) {
                return "已作废"
            } else if (row.states === 100) {
                return "移动终端接单"
            }
        },
        estimateLevelFormat(row, column) {
            if (row.estimateLevel === "1") {
                return "没有服务"
            } else if (row.estimateLevel === "2") {
                return "不满意"
            } else if (row.estimateLevel === "3") {
                return "服务一般"
            } else if (row.estimateLevel === "4") {
                return "基本满意"
            } else if (row.estimateLevel === "5") {
                return "非常满意"
            }
        },
        // 显示表单弹框
        async detailsVisit(title, row) {
            if (title === "新增") {
                this.showTitle = title
                this.showVisit = true
            } else {
                this.showTitle = title
                await this.getDetails(row.id)
                this.showVisit = true
            }
            // 获取服务类型
            this.$refs.visitDialog &&
                this.$refs.visitDialog.getServiceTypeList()
            // 获取套餐类型
            this.$refs.visitDialog && this.$refs.visitDialog.getEnsureList()
        },
        //派发
        payOut(row) {
            request({
                url: "/jjyl/servicePgd/info/Distribute",
                method: "POST",
                data: {
                    ...row,
                    states: 1,
                    id: row.id,
                },
            }).then((res) => {
                if (res.code === 200) {
                    this.closeWindow()
                    this.$message.success("派发成功")
                    this.$emit("updateList")
                } else {
                    this.$message.error("派发失败")
                }
            })
        },
        getDetails(id) {
            request({
                url: "/jjyl/servicePgd/info/findServicepgdById",
                method: "POST",
                data: {
                    id: id,
                },
            }).then((res) => {
                if (res.code === 200) {
                    if (res.content) {
                        this.orderInfo = res.content
                    } else {
                        this.orderInfo = {}
                    }
                }
            })
        },
        QuerySearch() {
            this.getDataList()
        },
        chehui(row) {
            this.$confirm("此操作将撤回该信息, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                request({
                    url: "/jjyl/servicePgd/info/withdraw",
                    method: "POST",
                    data: {
                        id: row.id,
                        states: row.states,
                        appStates: row.appStates,
                    },
                }).then((res) => {
                    if (res.code === 200) {
                        this.getDataList()
                    }
                })
            })
        },
        handleSelectionChange(val) {},
        handleSizeChange(val) {
            this.query.pageSize = val
            this.getDataList()
        },
        handleCurrentChange(val) {
            this.query.pageNum = val
            this.getDataList()
        },
    },
}
</script>

<style lang='less' scoped>
.QuerySearchBtn {
    margin-left: 60px;
}

.table-operation {
    width: 100%;
    display: flex;
    cursor: pointer;
    justify-content: space-between;
}

.labelImportBtn {
    margin: 0 10px;

    span {
        width: 70px;
        height: 40px;
        text-align: center;
        display: inline-block;
        line-height: 40px;
        font-size: 14px;
        background-color: #409eff;
        cursor: pointer;
        color: #ffffff;
        border-radius: 5px;
    }
}
.elder_manage_title {
    position: relative;
    width: 100%;
    margin-bottom: 15px;
    &::after {
        position: absolute;
        left: 120px;
        right: 0;
        display: block;
        content: "";
        border-bottom: 1px solid #e4e7ed;
    }
    .title {
        box-sizing: border-box;
        display: inline-block;
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #409eff;
        font-size: 14px;
        border: 1px solid #e4e7ed;
        border-bottom: none;
        border-radius: 4px 4px 0 0;
        box-sizing: border-box;
        background: #ffffff;
    }
}
/deep/ .search_wrapper {
    display: flex;
    flex-direction: column;
    position: relative;
    background: #f1f2f6;
    box-shadow: 0 0 6px rgba(151, 151, 151, 0.16);
    overflow: hidden;
    border-radius: 4px;
    .search_head {
        background: #fff;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        color: rgb(0, 0, 0);
        border-color: rgb(217, 217, 217);
        padding: 6px 15px;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
    }
    .search_content {
        padding: 15px 20px 0px 5px;
        border: 1px solid rgb(217, 217, 217);
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .search_inline {
        width: 100%;
    }
    .arrowDown {
        width: 28px;
        height: 28px;
        background: #edf2f0;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 50%;
        bottom: -14px;
        transform: translate(-50%, 0px);
        border-radius: 50%;
        z-index: 2;
        cursor: pointer;
    }
}
.searchDomw {
    cursor: pointer;
}
</style>
